import { useDispatch } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo, useCallback } from 'react';

import AdvancedHotkey from './component';
import { requestGetOrders } from '../../../store/orders/orders.actions';

export const messages = defineMessages({
  name: {
    description: 'reload orders grid hotkey',
    defaultMessage: 'Reload Orders grid',
    id: 'KHisD1',
  },
});

export const hotkey = ['o', 'r'];
export const barcodeContent = '+2D0CD19741AC=';

const ReloadOrdersGridHotkey = ({ children }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const onUpdate = useCallback(() => {
    dispatch(requestGetOrders());
  }, [dispatch]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['or'],
      hotkey,
      handler: onUpdate,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: true,
    }),
    [intl, onUpdate],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

ReloadOrdersGridHotkey.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ReloadOrdersGridHotkey;
